import ManzanarData from "../../../../src/components/manzanar-data.js";
import * as React from 'react';
export default {
  ManzanarData,
  React
};